import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Shimmer from '../Shimmer/Shimmer';
import { STEPPER_SKELETON_DEFAULT_STEPS, STEPPER_VARIANT, STEPPER_VARIANTS } from './constants';

// Loading state drawn with the Stepper's own rows: the same boxes, connector and label
// slots, filled with shimmer, so the bar keeps its height when the steps arrive.
const StepperSkeleton = ({ steps = STEPPER_SKELETON_DEFAULT_STEPS, variant = STEPPER_VARIANT.FULL, labelLines = 1, className, ...rest }) => {
    const lines = Math.max(1, Number(labelLines) || 1);
    const safeVariant = STEPPER_VARIANTS.has(variant) ? variant : STEPPER_VARIANT.FULL;
    const count = Math.max(1, Number(steps) || 0);
    return (
        <div
            className={classNames('ds-stepper', `ds-stepper--${safeVariant}`, 'ds-stepper--skeleton', className)}
            aria-busy="true"
            {...rest}
        >
            {Array.from({ length: count }, (_, index) => (
                <div key={index} className="ds-stepper__step">
                    <div className="ds-stepper__content">
                        <div className="ds-stepper__icon ds-stepper__placeholder">
                            <Shimmer width="100%" height="100%" radius={6} />
                        </div>
                        {safeVariant === STEPPER_VARIANT.FULL && (
                            <div className="ds-stepper__label ds-stepper__label--placeholder">
                                {Array.from({ length: lines }, (_, line) => (
                                    <Shimmer key={line} width={line === 0 ? '96px' : '64px'} height="1.35em" radius={4} />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

StepperSkeleton.propTypes = {
    /** Number of placeholder steps */
    steps: PropTypes.number,
    /** Label lines to reserve per step (2 when the real labels wrap, e.g. the Job Edit View) */
    labelLines: PropTypes.number,
    /** Layout to mirror */
    variant: PropTypes.oneOf(Object.values(STEPPER_VARIANT)),
    /** Extra class on the root */
    className: PropTypes.string,
};

export default StepperSkeleton;
